export const SITEPOLICY_DATA_ID = [
  {
    id: '1',
    sections: [
      {
        heading: 'Ketentuan Layanan BDD Web Invoicing System',
        lastUpdated: 'Terakhir diperbarui: 30 Mei 2023',
      },
      {
        title: 'Pratinjau',
        description:
          'Website BDD Web Invoicing System dioperasikan oleh Boleh Dicoba Digital. Di seluruh situs,istilah “kami” merujuk kepada Boleh Dicoba Digital.Boleh Dicoba Digital menawarkan website ini termasuk semua informasi, tools, dan layanan yang tersedia di situs ini untuk anda,sebagai user kami, yang dikondisikan sesuai dengan persetujuan anda akan semua ketentuan, kebijakan, dan pemberitahuan yang dimuat di sini.\n\nDengan mengunjungi situs kami dan/atau menggunakan layanan kami, anda terlibat dalam “Layanan” kami  dan sepakat untuk terikat oleh Ketentuan layanan ini, dan ketentuan-ketentuan lain yang dirujuk di sini. Ketentuan layanan ini berlaku untuk semua pengguna situs ini.\n\nMohon untuk membaca Ketentuan Layanan ini dengan saksama sebelum mengakses atau menggunakan website kami. Dengan mengakses atau menggunakan bagian manapun di situs ini, anda telah setuju untuk terikat oleh ketentuan layanan ini. Apabila anda tidak setuju dengan semua ketentuan layanan ini, anda tidak dapat mengakses atau menggunakan situs serta layanan yang ada di situs ini.\n\nAnda dapat mengulas versi yang paling baru dari ketentuan layanan ini kapanpun melalui halaman ini. Kami memiliki hak untuk memperbarui, mengubah, atau mengganti bagian manapun dari ketentuan layanan ini dengan memposting pembaruan dan/atau perubahan di website kami. Hal yang menjadi tanggung jawab anda untuk memeriksa halaman ini secara berkala jika ada perubahan. Penggunaan dan akses berkelanjutan anda pada situs ini setelah posting perubahan apapun pada ketentuan ini menandakan anda setuju mengenai perubahan tersebut.',
      },
      {
        title: 'Kondisi Umum',
        description:
          'Kami berhak untuk menolak layanan ini kepada siapapun untuk alasan apapun pada waktu kapanpun.\n\nAnda mengerti bahwa konten anda (tidak termasuk informasi pembayaran), bisa saja dipindahkan tanpa terenkripsi dan melibatkan (a) transmisi melalui berbagai jaringan; dan (b) perubahan untuk menyesuaikan dan beradaptasi terhadap persyaratan teknis dari jaringan atau perangkat tersambung. Informasi pembayaran dikelola oleh pihak ketiga yaitu Xendit.\n\nAnda setuju untuk tidak mereproduksi, menduplikasi, menggandakan, menjual, menjual kembali, atau mengeksploitasi bagian apapun dari layanan ini, penggunaan layanan ini, akses terhadap layanan ini, atau kontak apapun dengan website ini, tanpa ada izin tertulis dari kami.\n\nJudul yang digunakan dalam perjanjian tersebut disertakan hanya untuk kenyamanan dan tidak akan membatasi atau memengaruhi ketentuan ini.',
      },
      {
        title: 'Pengubahan Terhadap Layanan dan Harga',
        description:
          'Harga untuk layanan kami dapat berubah tanpa pemberitahuan sebelumnya dan harga yang tercantum di Invoice adalah harga yang sudah disepakati dan disetujui sebelumnya.\n\nKami berhak untuk kapanpun mengubah harga atau menghentikan layanan tanpa pemberitahuan sebelumnya.\n\nKami tidak bertanggung jawab kepada anda atau pihak ketiga manapun untuk modifikasi apapun, perubahan harga, penangguhan atau pemberhentian dari layanan kami.',
      },
      {
        title: 'Tautan Pihak Ketiga',
        description:
          'Layanan kami mungkin mencakup materi dari pihak ketiga.\n\nTautan pihak ketiga di situs ini mungkin mengarahkan anda ke website pihak ketiga. Kami tidak bertanggung jawab atas konten-konten, produk, layanan, dan ketentuan layanan yang tersedia di website pihak ketiga.\n\nMohon untuk mengulas secara saksama kebijakan-kebijakan pihak ketiga dan praktik-praktiknya. Pastikan anda mengerti sebelum anda terlibat dalam transaksi apapun. Komplain, klaim, tanggapan, atau pertanyaan mengenai produk-produk pihak ketiga harus diarahkan kepada pihak ketiga terkait.',
      },
      {
        title: 'Informasi Pribadi',
        description:
          'Penyerahan informasi pribadi anda melalui BDD Sales database mungkin diatur dalam perjanjian kontrak yang ditandatangani oleh pihak Boleh Dicoba Digital dan pihak Anda.\n\nJika tidak ada klausul mengenai pengaturan informasi pribadi, BIS tidak mempergunakan informasi pribadi untuk cookies, dan layanan pihak ketiga lainnya, silakan rujuk ke ',
        link: 'Kebijakan Privasi',
        href: '/site-policy/privacy-policy',
      },
      {
        title: 'Kesalahan, Kekeliruan, dan Kelalaian',
        description:
          'Terkadang mungkin ada informasi di situs kami atau di layanan kami yang mengandung kesalahan pengetikan, ketidakakuratan, atau kelalaian yang mungkin berkaitan dengan deskripsi produk, harga, promo, diskon, pajak, dan ketersediaan. Kami memegang hak untuk membenarkan kesalahan, ketidakakuratan, atau kelalaian, dan juga untuk mengubah atau memperbarui ataupun juga membatalkan produk jika informasi dari layanan terkait itu tidak akurat kapanpun tanpa ada pemberitahuan sebelumnya (termasuk setelah anda menyerahkan pesanan anda).',
      },
      {
        title: 'Penggunaan Terlarang',
        description:
          'Selain larangan lain yang diatur dalam ketentuan layanan, anda juga dilarang dalam menggunakan situs dan kontennya:',
        list: [
          {
            label: '(a) untuk tujuan-tujuan melawan hukum;',
          },
          {
            label:
              '(b) untuk meminta orang lain melakukan atau terlibat dalam tindakan melawan hukum;',
          },
          {
            label:
              '(c) untuk melanggar peraturan daerah, hukum nasional, serta regulasi international apapun;',
          },
          {
            label:
              '(d) untuk melanggar hak kepemilikan dan hak kekayaan intelektual kami atau pun orang lain;',
          },
          {
            label:
              '(e) untuk melecehkan, menyalahgunakan, menyinggung, membahayakan, memfitnah, meremehkan, mengintimidasi, atau mendiskriminasi berdasarkan Seks, Agama, Ras, Antargolongan, dan disabilitas;',
          },
          {
            label: '(f) untuk menyebarkan informasi menyimpang;',
          },
          {
            label:
              '(g) untuk mengirim atau menyebarkan virus perangkat lunak atau malicious code lain yang akan atau mungkin digunakan yang bisa mempengaruhi keberjalanan layanan layanan kami, dan website lainnya di internet;',
          },
          {
            label:
              '(h) untuk melakukan spam, phishing, pharming, pretext, spider, crawl, atau scrape;',
          },
          {
            label: '(i) untuk tujuan amoral atau pencabulan; atau',
          },
          {
            label:
              '(j) untuk mengganggu atau menghindar dari fitur keamanan layanan atau website lainnya, atau Internet pada umumnya. Kami memegang hak untuk menghentikan penggunaan anda akan layanan kami atau website terkait karena melanggar We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses.',
          },
        ],
        styledList: false,
      },
      {
        title: 'Penafian Garansi, Pembatasan Tanggung Jawab',
        description:
          'Kami tidak menanggung atau menjamin bahwa penggunaan anda atas layanan kami akan selalu lancar, tepat waktu, aman, atau bebas dari kesalahan.\n\nAnda menyetujui bahwa dari waktu ke waktu kami bisa saja menghapus atau membatalkan beberapa layanan tanpa pemberitahuan sebelumnya.Anda secara jelas menyetujui bahwa penggunaan anda merupakan risiko yang anda tanggung sendiri.',
      },
      {
        title: 'Penggantian Kerugian',
        description:
          'Anda setuju untuk mengganti rugi, membela, dan membebaskan Boleh DIcoba Digital dan induk, anak perusahaan, afiliasi, mitra, pejabat, direktur, agen, kontraktor, pemberi lisensi, penyedia layanan, subkontraktor, pemasok, pemagang, dan karyawan, dari segala klaim atau permintaan, termasuk biaya pengacara yang wajar, yang dibuat oleh pihak ketiga mana pun karena atau timbul dari pelanggaran anda terhadap ketentuan layanan ini atau dokumen yang menyertai, atau pelanggaran anda terhadap hukum apapun atau hak pihak ketiga',
      },
      {
        title: 'Keterpisahan',
        description:
          'Dalam hal ada ketentuan dari Ketentuan Layanan ini yang dianggap melanggar hukum, batal atau tidak dapat dilaksanakan, ketentuan tersebut tetap dapat dilaksanakan sejauh yang diizinkan oleh undang-undang yang berlaku, dan bagian yang tidak dapat dilaksanakan akan dianggap terputus dari Ketentuan Layanan ini, penentuan tersebut tidak akan mempengaruhi validitas dan keberlakuan ketentuan lainnya yang tersisa.',
      },
      {
        title: 'Penghentian',
        description:
          'Kewajiban dan tanggung jawab para pihak yang terjadi sebelum tanggal penghentian akan tetap berlaku setelah penghentian perjanjian ini untuk semua tujuan.\n\nKetentuan Layanan ini berlaku efektif kecuali dan sampai diakhiri baik itu oleh anda atau kami. Anda dapat mengakhiri ketentuan layanan ini kapan saja dengan memberitahu kami bahwa anda tidak ingin menggunakan layanan kami, atau ketika anda berhenti menggunakan situs kami.\n\nJika menurut penilaian kami anda gagal, atau kami mencurigai anda telah gagal, untuk mematuhi syarat atau ketentuan apapun dari ketentuan layanan ini, kami juga bisa menghentikan persetujuan ini kapanpun tanpa pemberitahuan, dan anda akan tetap bertanggung jawab untuk semua jumlah yang jatuh tempo sampai dan termasuk tanggal penghentian; dan/atau karenanya dapat menolak akses anda ke layanan kami.',
      },
      {
        title: 'Keseluruhan Persetujuan',
        description:
          'Kegagalan kami untuk menjalankan atau menegakkan hak atau ketentuan apapun dari ketentuan layanan ini bukan merupakan pengesampingan hak atau ketentuan tersebut.\n\nKetentuan layanan ini dan kebijakan atau standar operasional apapun yang dimuat oleh kami di situs ini atau dalam kaitannya dengan layanan merupakan keseluruhan perjanjian dan pemahaman antara anda dan kami dan mengatur penggunaan anda terhadap layanan kami, menggantikan perjanjian sebelumnya, komunikasi, dan proposal, apakah lisan atau tertulis, di antara anda dan kami (termasuk, tetapi tidak terbatas pada, versi sebelumnya dari ketentuan layanan).',
      },
      {
        title: 'Hukum Pemerintah',
        description:
          'Ketentuan layanan ini dan persetujuan terpisah mengenai layanan yang kami sajikan untuk anda diatur dan ditafsirkan sejalan dengan peraturan hukum di Indonesia.',
      },
      {
        title: 'Perubahan Terhadap Ketentuan Layanan',
        description:
          'Anda dapat mengulas versi paling terbaru dari ketentuan layanan ini kapanpun di halaman ini.Kami memegang hak, atas kebijakan kami sendiri, untuk memperbarui, mengubah, atau mengganti bagian manapun dari ketentuan layanan ini dengan memposting pembaruan dan perubahan di website kami. Yang menjadi tanggung jawab anda adalah untuk memeriksa website kami secara berkala untuk perubahan. Penggunaan atau akses berlanjut anda ke website kami atau layanan kami setelah perubahan diposting ke ketentuan layanan ini menandakan persetujuan anda.',
      },
      {
        title: 'Kontak Kami',
        description:
          'Pertanyaan mengenai Ketentuan Layanan harus dikirimkan kepada kami melalui email:\nfinance@bolehdicoba.com.\n\nInformasi kontak kami adalah sebagai berikut:\nFinance Department - Boleh Dicoba Digital\nfinance@bolehdicoba.com\nLima Building, Jl. Sunda No.56-61, Kb. Pisang, Kec. Sumur Bandung, Kota Bandung, Jawa Barat 40112, Indonesia\n+62818 0575 7585',
      },
    ],
  },
  {
    id: '2',
    sections: [
      {
        heading: 'Kebijakan Privasi BDD Web Invoicing System',
        lastUpdated: 'Terakhir diperbarui: 30 Mei 2023',
      },
      {
        title: 'Pratinjau',
        description:
          'Kebijakan Privasi ini menjelaskan kebijakan-kebijakan dan prosedur Kami dalam pengumpulan, penggunaan, dan penampilan informasi Anda ketika Anda menggunakan layanan Kami, dan memberitahu Anda terkait hak privasi Anda dan bagaimana hukum melindungi Anda.\n\nKami menggunakan data pribadi Anda untuk menyajikan dan meningkatkan layanan Kami. Dengan menggunakan layanan Kami, Anda setuju terhadap pengumpulan dan penggunaan informasi yang sejalan dengan Kebijakan Privasi ini.',
      },
      {
        title: 'Definisi',
        description: 'Untuk tujuan kebijakan privasi ini:',
        list: [
          {
            label:
              'Akun - berarti akun unik yang dibuat untuk Anda untuk mengakses layanan Kami atau sebagian dari layanan Kami.',
          },
          {
            label:
              'Afiliasi - berarti satu entitas yang mengendalikan, dikendalikan oleh, atau di bawah kendali bersama satu kelompok, di mana "kendali" berarti kepemilikan 50% atau lebih dari saham, bunga equity, atau sekuritas lainnya yang berhak untuk memberi suara untuk pemilihan direktur atau otoritas pengelola lainnya.',
          },
          {
            label:
              'Perusahaan - (dirujuk sebagai "Perusahaan" atau "Kami" dalam persetujuan ini) merujuk kepada Boleh Dicoba Digital, Jl. Sunda No.56-61, Kb. Pisang, Kec. Sumur Bandung, Kota Bandung, Jawa Barat 40112, Indonesia.',
          },
          {
            label:
              'Cookies - adalah file-file kecil yang disimpan di perangkat Anda (komputer, perangkat mobile, dan perangkat lain) oleh website Kami yang memuat detail tentang riwayat penjelajahan website Anda.',
          },
          {
            label: 'Negara - mengacu ke: Indonesia.',
          },
          {
            label:
              'Perangkat - berarti perangkat apapun yang dapat mengakses Layanan Kami seperti komputer, telepon seluler, atau tablet digital.',
          },
          {
            label:
              'Data Pribadi - adalah segala informasi yang berkaitan individu teridentifikasi atau yang dapat diidentifikasi.',
          },
          {
            label: 'Layanan -  mengacu ke pada website.',
          },
          {
            label:
              'Penyedia Layanan - berarti pihak legal manapun yang memproses data atas nama Perusahaan. Hal ini merujuk pada individu atau perusahaan pihak ketiga yang dipekerjakan oleh perusahaan untuk memfasilitasi layanan, untuk menyajikan layanan atas nama perusahaan, untuk menjalankan layanan, atau untuk mendukung perusahaan dalam menganalisis bagaimana layanan tersebut digunakan.',
          },
          {
            label:
              'Data Penggunaan - merujuk kepada data yang dikumpulkan secara otomatis, baik itu diperoleh dari penggunaan layanan atau dari infrastruktur layanan tersebut (contoh, durasi kunjungan halaman).',
          },
          {
            label:
              'Anda - berarti individu yang mengakses atau menggunakan layanan ini, atau perusahaan, atau entitas legal lainnya yang mempercayakan kepada individu yang mengakses dan menggunakan layanan sebagaimana mestinya.',
          },
          {
            label:
              'Website - merujuk kepada BDD Web Invoicing System, yang dapat diakses di ',
            link: 'https://bis.bolehdicoba.com/',
          },
        ],
        styledList: true,
      },
      {
        title: 'Pengumpulan dan Penggunaan Data Pribadi Anda',
        subcontent: [
          {
            title: 'Tipe-tipe Data yang Dikumpulkan',
            deepSubContent: [
              {
                title: 'Data Pribadi',
                description:
                  'Ketika menggunakan layanan Kami, Kami mungkin meminta Anda untuk menyajikan Kami beberapa informasi pribadi Anda yang dapat digunakan untuk menghubungi atau mengenali Anda. Data tersebut dapat mencakup, tetapi tidak terbatas pada:',
                list: [{ label: 'Data Penggunaan' }],
                styledList: true,
              },
              {
                title: 'Data Penggunaan',
                description:
                  'Data penggunaan dikumpulkan secara otomatis ketika menggunakan layanan.\n\nData pengguna dapat mencakup informasi seperti alamat IP perangkat Anda, tipe browser, versi browser, halaman di layanan Kami yang Anda kunjungi, waktu dan tanggal kunjungan, waktu yang dihabiskan dari kunjungan Anda, pengenal unik perangkat dan data diagnostik lainnya.\n\nKetika Anda mengakses layanan melalui perangkat mobile, Kami mungkin mengumpulkan beberapa informasi, termasuk, tetapi tidak terbatas pada, tipe perangkat mobile, sistem operasi perangkat Anda, tipe browser internet yang Anda gunakan, unique ID perangkat Anda, Alamat IP dari perangkat Anda, dan data diagnostik lainnya.\n\nKami mungkin juga mengumpulkan informasi yang dikirim browser Anda saat Anda mengunjungi layanan Kami atau saat Anda mengakses layanan Kami melalui perangkat mobile.',
              },
              {
                title: 'Teknologi Pelacak dan Cookies',
                description:
                  'Kami menggunakan cookies dan teknologi pelacak serupa untuk melacak aktifitas di layanan Kami dan menyimpan beberapa informasi. Teknologi pelacak yang digunakan adalah beacon, tag, dan script untuk mengumpulkan dan melacak informasi dan untuk mengumpulkan informasi serta untuk meningkatkan dan menganalisis layanan Kami. Teknologi yang Kami gunakan termasuk:',
                list: [
                  {
                    label:
                      'Cookies atau Browser Cookies. cookie merupakan file kecil yang disimpan di perangkat Anda. Anda dapat mengatur browser Anda untuk menolak semua cookies atau mengatur kapan cookie dikirim. Meskipun demikian, jika Anda tidak menerima cookies, Anda mungkin tidak dapat menggunakan sebagian dari layanan Kami.',
                  },
                  {
                    label:
                      'Web Beacons. Bagian-bagian tertentu dalam layanan Kami dan email Kami mungkin mencakup file elektronik kecil yang disebut sebagai web beacons (juga disebut clear gifs, pixel tags, dan single-pixel gifs) yang memungkinkan perusahan, sebagai contoh, untuk menghitung user yang sudah mengunjungi halaman tertentu, membuka email, dan untuk kepentingan statistik website lainnya.',
                  },
                ],
                styledList: true,
                middleText:
                  'Cookies dapat menjadi "Persistent Cookies" atau "Session Cookies". Persistent Cookies tetap ada di dalam perangkat Anda ketika sedang di luar jaringan, sementara Session Cookies dihapus segera setelah Anda menutup browser Anda.',
              },
            ],
          },
          {
            title: 'Penggunaan Data Pribadi Anda',
            description:
              'Perusahaan mungkin menggunakan data pribadi Anda untuk keperluan berikut:',
            list: [
              {
                label:
                  'Untuk menyajikan dan merawat layanan Kami, termasuk untuk memonitor penggunaan Anda di layanan Kami.',
              },
              {
                label:
                  'Untuk mengelola akun Anda: untuk mengelola pendaftaran Anda sebagai user dari layanan Kami. Data pribadi yang Anda serahkan dapat memberikan Anda akses terhadap beberapa fungsi berbeda dari layanan yang tersedia untuk Anda sebagai user terdaftar.',
              },
              {
                label:
                  'Untuk performa sebuah kontrak: pengembangan, kepatuhan, dan keberjalanan kontrak pembelian untuk produk, barang, atau jasa yang telah Anda beli atau dari kontrak lain bersama Kami melalui layanan ini.',
              },
              {
                label:
                  'Untuk menghubungi Anda: untuk menghubungi Anda melalui email, panggilan telepon, SMS, atau bentuk komunikasi elektronik lainnya, seperti push notification mengenai update atau informasi lain yang berkaitan dengan functionalities, produk atau jasa, termasuk pembaruan keamanan, ketika implementasinya diperlukan dan dalam kewajaran.',
              },
              {
                label:
                  'Untuk menyajikan Anda berita, penawaran khusus, dan informasi umum mengenali layanan lain yang Kami tawarkan yang sama dengan apa yang telah Anda beli kecuali Anda memilih untuk tidak menerima informasi tersebut.',
              },
              {
                label:
                  'Untuk mengelola permintaan Anda: untuk mengatur dan mengelola permintaan Anda terhadap Kami.',
              },
              {
                label:
                  'Untuk perpindahan bisnis: Kami mungkin menggunakan informasi Anda untuk mengevaluasi atau melakukan merger, divestasi, restrukturisasi, reorganisasi, pembubaran, penjualan, atau perpindahan lain baik itu sebagian atau keseluruhan asset Kami, baik itu sebagai pertimbangan dari bagian dari pernyataan bankrut, likuidasi, atau proses serupa, yang mana data pribadi yang disimpan oleh Kami sebagai bagian dari pengguna layanan adalah bagian dari aset yang dipindahkan.',
              },
              {
                label:
                  'Untuk tujuan lain: Kami mungkin menggunakan informasi Anda untuk tujuan lain, seperti analisis data, mengenali tren penggunaan, menentukan keefektifan kampanye-kampanye promosi Kami, dan untuk mengevaluasi serta meningkatkan layanan, produk, pemasaran dan pengalaman untuk Anda.',
              },
            ],
            middleText:
              'Kami mungkin membagikan informasi pribadi Anda di situasi-situasi berikut:',
            middleList: [
              {
                label:
                  'Dengan penyedia layanan: Kami membagikan informasi pribadi Anda dengan penyedia layanan untuk memonitor dan menganalisis penggunaan Anda akan layanan Kami.',
              },
              {
                label:
                  'Untuk perpindahan bisnis: Kami mungkin membagikan atau memindahkan informasi pribadi Anda dalam kaitan atau selama negosiasi dari merger, penjualan aset, keperluan keuangan, atau akuisisi semua atau sebagian dari bisnis Kami ke perusahaan lain.',
              },
              {
                label:
                  'Dengan Afiliasi: Kami mungkin membagikan informasi pribadi Anda dengan afiliasi Kami, dalam kondisi Kami memerlukan afiliasi tersebut untuk mengindahkan kebijakan privasi ini. Afiliasi termasuk perusahaan induk dan subsidiari lainnya, partner joint venture atau perusahaan lainnya yang Kami kendalikan atau di bawah kendali yang sama dengan Kami.',
              },
              {
                label:
                  'Dengan rekan bisnis: Kami mungkin membagikan dengan rekan bisnis Kami untuk menawarkan Anda produk-produk, layanan, atau promosi tertentu.',
              },
              {
                label:
                  'Dengan pengguna lain: ketika Anda membagikan informasi pribadi atau berinteraksi di area publik dengan pengguna lain, informasi tersebut bisa saja dilihat oleh semua pengguna dan bisa disebarkan secara publik ke luar.',
              },
              {
                label:
                  'Dengan persetujuan Anda: Kami mungkin membuka informasi pribadi Anda untuk tujuan lain dengan persetujuan Anda.',
              },
            ],
            styledList: true,
          },
          {
            title: 'Penyimpanan Data Pribadi Anda',
            description:
              'Perusahaan akan menyimpan data pribadi Anda sepanjang yang diperlukan untuk tujuan-tujuan yang dicantumkan di dalam kebijakan privasi ini. Kami akan menyimpan dan menggunakan data pribadi Anda sejauh yang diperlukan untuk mematuhi kewajiban legal (sebagai contoh, jika Kami diperlukan untuk menyimpan data Anda untuk mematuhi hukum yang berlaku), menyelesaikan sengketa, dan melaksanakan persetujuan dan kebijakan hukum Kami.\n\nPerusahaan juga akan menyimpan data penggunaan untuk keperluan analisis internal. Data penggunaan umumnya disimpan untuk waktu yang pendek, kecuali ketika data ini digunakan untuk menguatkan pengamanan atau untuk meningkatkan fungsi layanan Kami, atau Kami secara hukum diwajibkan untuk menyimpan data ini untuk waktu yang lebih lama.',
          },
          {
            title: 'Pemindahan Data Pribadi Anda',
            description:
              'Informasi Anda, termasuk data pribadi, diproses oleh kantor perusahaan yang beroperasi dan di tempat lain yang mana para pihak terlibat dalam pemrosesannya. Hal ini berarti bahwa informasi ini bisa saja dipindahkan ke — dan dijaga dalam — komputer yang berlokasi di luar area, kota/kabupaten, provinsi, negara, dan area yurisdiksi pemerintahan Anda dimana hukum perlindungan data Anda berbeda dengan area yurisdiksi di mana Anda berasa.\n\nPersetujuan Anda terhadap kebijakan privasi ini diikuti oleh penyerahan informasi-informasi terkait Anda yang mewakili kesediaan Anda terhadap pemindahan ini.\n\nPerusahaan akan mengambil semua langkah yang diperlukan secara wajar untuk memastikan bahwa data Anda diperlakukan secara aman dan sejalan dengan kebijakan privasi ini dan tidak ada pemindahan data pribadi Anda yang akan dilakukan ke organisasi atau ke negara kecuali ada kendali yang cukup termasuk keamanan data dan informasi pribadi Anda lainnya.',
          },
          {
            title: 'Penghapusan Data Pribadi Anda',
            description:
              'Anda memiliki hak untuk menghapus atau meminta bantuan Kami dalam penghapusan data pribadi Anda yang Kami kumpulkan.\n\nLayanan Kami bisa saja memberikan Anda kemampuan untuk menghapus informasi terkait dari dalam layanan Kami.\n\nAnda dapat memperbarui, mengubah, atau menghapus informasi pribadi Anda kapanpun dengan masuk ke akun Anda, jika Anda memilikinya, dan mengaturnya dari peraturan akun Anda yang memungkinkan Anda untuk mengelola informasi pribadi Anda. Anda bisa juga menghubungi Kami untuk meminta akses, membetulkan, atau menghapus informasi pribadi apapun yang Anda serahkan ke Kami.\n\nTolong dicatat, bagaimanapun, kita bisa saja perlu menyimpan informasi-informasi tertentu ketika Kami memiliki kewajiban hukum atau dasar hukum untuk melakukan hal tersebut.',
          },
          {
            title: 'Pembukaan Data Pribadi Anda',
            deepSubContent: [
              {
                title: 'Transaksi Bisnis',
                description:
                  'Jika perusahaan terlibat dalam merger, akuisisi, atau penjualan aset, data pribadi Anda bisa saja dipindahkan. Kami akan memberikan pemberitahuan sebelum pemindahan data personal Anda dan menjadi tunduk ke kebijakan privasi yang berbeda.',
              },
              {
                title: 'Penegakkan Hukum',
                description:
                  'Dalam situasi tertentu, perusahaan mungkin perlu untuk membuka data pribadi Anda jika diperlukan demikian oleh hukum atau sebagai tanggapan dari permintaan valid oleh pihak berwenang (contoh. Pengadilan atau badan pemerintahan tertentu).',
              },
              {
                title: 'Keperluan Hukum Lainnya',
                description:
                  'Perusahaan mungkin membuka data pribadi Anda dengan itikad baik bahwa tindakan tersebut diperlukan untuk:',
                list: [
                  { label: 'Mematuhi kewajiban hukum' },
                  {
                    label:
                      'Melindungi dan membela hak atau kepemilikan perusahaan',
                  },
                  {
                    label:
                      'Mencegah atau menginvestigasi kemungkinan tindakan pelanggaran dalam kaitannya dengan layanan Kami',
                  },
                  {
                    label:
                      'Melindungi keamanan pribadi pengguna layanan atau publik',
                  },
                  { label: 'Melindungi dari tanggung jawab hukum' },
                ],
                styledList: true,
              },
            ],
          },
          {
            title: 'Keamanan Data Pribadi Anda',
            description:
              'Keamanan data pribadi Anda penting bagi kam, tetapi harap diingat tidak ada metode transmisi melalui internet, atau metode penyimpanan elektronik yang 100% aman. Sementara Kami berusaha keras untuk menggunakan cara-cara yang dapat diterima secara komersil untuk perlindungan data pribadi Anda, Kami tidak dapat sepenuhnya menjamin keamanan absolutnya.',
          },
        ],
      },
      {
        title: 'Privasi anak',
        description:
          'Layanan Kami tidak menunjukkan siapapun di bawah usia 17 tahun. Kami tidak secara sadar mengumpulkan informasi pribadi teridentifikasi oleh siapapun di bawah usia 17 tahun. Jika Anda merupakan orang tua atau wali dan Anda mengetahui bahwa anak Anda menyajikan data pribadinya kepada Kami, mohon untuk mengontak Kami. Jika Kami mengetahui bahwa Kami mengumpulkan data pribadi dari siapapun yang berusia di bawah 17 tahun tanpa verifikasi persetujuan orang tua, Kami akan mengambil langkah untuk menghapus informasi tersebut dari server Kami.\n\nJika Kami perlu mengAndalkan persetujuan sebagai dasar hukum untuk memproses informasi Anda dan negara Anda memerlukan persetujuan dari orang tua, Kami dapat meminta persetujuan orang tua Anda sebelum Kami mengumpulkan dan menggunakan informasi tersebut.',
      },
      {
        title: 'Tautan ke Website lain',
        description:
          'Layanan Kami mungkin berisi tautan ke situs web lain yang tidak dioperasikan oleh Kami. Jika Anda mengklik tautan pihak ketiga, Anda akan diarahkan ke situs pihak ketiga tersebut. Kami sangat menyarankan Anda untuk meninjau Kebijakan Privasi dari setiap situs yang Anda kunjungi.\n\nKami tidak memiliki kendali dan tidak bertanggung jawab atas konten, kebijakan privasi, atau praktik situs atau layanan pihak ketiga mana pun.',
      },
      {
        title: 'Perubahan Kebijakan Privasi',
        description:
          'Kami dapat memperbarui Kebijakan Privasi Kami dari waktu ke waktu. Kami akan memberi tahu Anda tentang setiap perubahan dengan memposting Kebijakan Privasi baru di halaman ini.\n\nKami akan memberi tahu Anda melalui email dan/atau pemberitahuan penting di Layanan Kami, sebelum perubahan berlaku dan memperbarui tanggal "Pembaruan terakhir" di bagian atas Kebijakan Privasi ini.\n\nAnda disarankan untuk meninjau Kebijakan Privasi ini secara berkala untuk setiap perubahan. Perubahan pada Kebijakan Privasi ini efektif saat diposting di halaman ini.',
      },
      {
        title: 'Perubahan Kebijakan Privasi',
        description:
          'Kami dapat memperbarui Kebijakan Privasi Kami dari waktu ke waktu. Kami akan memberi tahu Anda tentang setiap perubahan dengan memposting Kebijakan Privasi baru di halaman ini.\n\nKami akan memberi tahu Anda melalui email dan/atau pemberitahuan penting di Layanan Kami, sebelum perubahan berlaku dan memperbarui tanggal "Pembaruan terakhir" di bagian atas Kebijakan Privasi ini.\n\nAnda disarankan untuk meninjau Kebijakan Privasi ini secara berkala untuk setiap perubahan. Perubahan pada Kebijakan Privasi ini efektif saat diposting di halaman ini.',
      },
      {
        title: 'Menghubungi Kami',
        description:
          'Jika Anda memiliki pertanyaan terkait Kebijakan Privasi ini, Anda dapat menghubungi kami di:',
        list: [
          {
            label: 'finance@bolahdicoba.com',
          },
        ],
        styledList: true,
      },
    ],
  },
  {
    id: '3',
    sections: [
      {
        title: 'Kebijakan dan Ketentuan Pengembalian Dana',
        description:
          'Jika Anda menerima invoice yang tidak sesuai  dengan layanan yang Anda terima, Harap hubungi Customer Support kami melalui nomor Whatsapp berikut 0813 3239 1051 atau melalui email ke finance@bolehdicoba.com untuk mengajukan permohonan pengembalian dana dengan mencantumkan informasi detail mengenai:',
        list: [
          { label: 'Nama Perusahaan/Brand' },
          { label: 'Nomor Invoice' },
          { label: 'Tanggal Invoice' },
          { label: 'Detail keluhan' },
          { label: 'Bukti-bukti terkait keluhan' },
        ],
        middleText:
          'Pengembalian dana yang telah anda bayarkan akan diproses melalui transfer bank. Pengembalian dana hanya bisa kami lakukan jika kami sudah menyetujui keluhan yang kami terima.',
        styledList: true,
      },
    ],
  },
];

export const SITEPOLICY_DATA_EN = [
  {
    id: '1',
    sections: [
      {
        heading: 'BDD Web Invoicing System Terms Of Service',
        lastUpdated: 'Last updated: 30th May 2023',
      },
      {
        title: 'Overview',
        description:
          'This BDD Web Invoicing System website is operated by Boleh Dicoba Digital. Throughout the site, the terms “we”, “us” and “our” refer to Boleh Dicoba Digital. Boleh Dicoba Digital offers this website, including all information, tools, and Services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies, and notices stated here.\n\nBy visiting our site and/ or purchasing something from us, you engage in our “Service” and agree to be bound by the following terms and conditions (“Terms of Service”, “Terms”), including those additional terms and conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply to all users of the site, including without limitation users who are browsers and customers.\n\nPlease read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, you may not access the website or use any Services. If these Terms of Service are considered an offer, acceptance is expressly limited to these Terms of Service.\n\nYou can review the most current version of the Terms of Service at any time on this page. We reserve the right to update, change or replace any part of these Terms of Service by posting updates and/or changes to our website. It is your responsibility to check this page periodically for changes. Your continued use of or access to the website following the posting of any changes constitutes acceptance of those changes.',
      },
      {
        title: 'General Conditions',
        description:
          'We reserve the right to refuse service to anyone for any reason at any time.\n\nYou understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to the technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.\n\nYou agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without written permission from us.\n\nThe headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.',
      },
      {
        title: 'Modifications to The Service & Prices',
        description:
          'Prices for our services are subject to change without notice.\n\nWe reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time.\n\nWe shall not be liable to you or to any third party for any modification, price change, suspension, or discontinuance of the Service.',
      },
      {
        title: 'Third-Party Links',
        description: `Our Service may include materials from third parties.\n\nThird-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or Services of third parties.\n\nWe are not liable for any harm or damages related to the purchase or use of goods, Services, resources, content, or any other transactions made in connection with any third-party websites. Please review carefully the third-party's policies and practices and make sure you understand them before you engage in any transaction. Complaints, claims, concerns, or questions regarding third-party products should be directed to the third party.`,
      },
      {
        title: 'Personal Information',
        description:
          'Your submission of personal information through the BDD Sales database is governed by our Privacy Policy. To view our Privacy Policy, please see ',
        link: 'Privacy Policy',
        href: '/site-policy/privacy-policy',
      },
      {
        title: 'Errors, Inaccuracies, And Omissions',
        description:
          'Occasionally there may be information on our site or in the Service that contains typographical errors, inaccuracies, or omissions that may relate to product descriptions, pricing, promotions, offers, product shipping charges, transit times, and availability. We reserve the right to correct any errors, inaccuracies, or omissions, and to change or update information or cancel orders if any information in the Service or on any related website is inaccurate at any time without prior notice (including after you have submitted your order).\n\nWe undertake no obligation to update, amend or clarify information in the Service or on any related website, including without limitation, pricing information, except as required by law. No specified update or refresh date applied in the Service or on any related website should be taken to indicate that all information in the Service or on any related website has been modified or updated.',
      },
      {
        title: 'Prohibited Uses',
        description:
          'In addition to other prohibitions, as set forth in the Terms of Service, you are prohibited from using the site or its content:',
        list: [
          {
            label: 'for any unlawful purpose',
          },
          {
            label:
              'to solicit others to perform or participate in any unlawful acts',
          },
          {
            label:
              'to violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances',
          },
          {
            label:
              'to infringe upon or violate our intellectual property rights or the intellectual property rights of others;',
          },
          {
            label:
              'to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability;',
          },
          {
            label: 'to submit false or misleading information;',
          },
          {
            label:
              'to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; ',
          },
          {
            label: 'to spam, phish, pharm, pretext, spider, crawl, or scrape; ',
          },
          {
            label: 'for any obscene or immoral purpose; or ',
          },
          {
            label:
              'to interfere with or circumvent the security features of the Service or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses.',
          },
        ],
        styledList: false,
      },
      {
        title: 'Disclaimer Of Warranties; Limitation Of Liability',
        description: `We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure, or error-free.\n\nWe do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.\n\nYou agree that from time to time we may remove the service for indefinite periods of time or cancel the service at any time, without notice to you.\n\nYou expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and Services delivered to you through the service are (except as expressly stated by us) provided 'as is' and 'as available' for your use, without any representation, warranties, or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.\n\nIn no case shall Boleh Dicoba Digital, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility.\n\nBecause some states or jurisdictions do not allow the exclusion or the limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.
          `,
      },
      {
        title: 'Indemnification',
        description: `You agree to indemnify, defend and hold harmless Boleh Dicoba Digital and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns, and employees, harmless from any claim or demand, including reasonable attorneys' fees, made by any third-party due to or arising out of your breach of these Terms of Service or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.`,
      },
      {
        title: 'Severability',
        description:
          'In the event that any provision of these Terms of Service is determined to be unlawful, void or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of any other remaining provisions.',
      },
      {
        title: 'Termination',
        description:
          'The obligations and liabilities of the parties incurred prior to the termination date shall survive the termination of this agreement for all purposes.\n\nThese Terms of Service are effective unless and until terminated by either you or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or when you cease using our site.\n\nIf in our sole judgment, you fail, or we suspect that you have failed, to comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time without notice and you will remain liable for all amounts due up to and including the date of termination; and/or accordingly may deny you access to our Services (or any part thereof).',
      },
      {
        title: 'Entire Agreement',
        description:
          'The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision.\n\nThese Terms of Service and any policies or operating rules posted by us on this site or in respect to The Service constitutes the entire agreement and understanding between you and us and govern your use of the Service, superseding any prior or contemporaneous agreements, communications and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service).\n\nAny ambiguities in the interpretation of these Terms of Service shall not be construed against the drafting party.',
      },
      {
        title: 'Governing Law',
        description:
          'These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of Indonesia.',
      },
      {
        title: 'Changes To Terms Of Service',
        description:
          'You can review the most current version of the Terms of Service at any time at this page.We reserve the right, at our sole discretion, to update, change or replace any part of these Terms of Service by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to our website or the Service following the posting of any changes to these Terms of Service constitutes acceptance of those changes.',
      },
      {
        title: 'Contact Information',
        description:
          'Questions about the Terms of Service should be sent to us at nanda@bolehdicoba.com.\n\nOur contact information is posted below:\n\nFinance Department - Boleh Dicoba Digital\n\nfinance@bolehdicoba.com\n\nLima Building, Jl. Sunda No.56-61, Kb. Pisang, Kec. Sumur Bandung, Kota Bandung, Jawa Barat 40112, Indonesia\n\n+62818 0575 7585',
      },
    ],
  },
  {
    id: '2',
    sections: [
      {
        heading: 'Privacy Policy for BDD Web Invoicing System',
        lastUpdated: 'Last updated: April 17, 2023',
      },
      {
        title: 'Privacy Policy',
        description:
          'This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.\n\nWe use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the Free Privacy Policy Generator.',
      },
      {
        title: 'Interpretation and Definitions',
        subcontent: [
          {
            title: 'Interpretation',
            description:
              'The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.',
          },
          {
            title: 'Definitions',
            description: 'For the purposes of this Privacy Policy:',
            list: [
              {
                label:
                  'Account - means a unique account created for You to access our Service or parts of our Service.',
              },
              {
                label:
                  'Affiliate - means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.',
              },
              {
                label:
                  'Company - (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Boleh Dicoba Digital, Jl. Sunda No.56-61, Kb. Pisang, Kec. Sumur Bandung, Kota Bandung, Jawa Barat 40112, Indonesia.',
              },
              {
                label:
                  'Cookies - are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.',
              },
              {
                label: 'Country - refers to: Indonesia',
              },
              {
                label:
                  'Device - means any device that can access the Service such as a computer, a cell phone or a digital tablet.',
              },
              {
                label:
                  'Personal Data - is any information that relates to an identified or identifiable individual.',
              },
              {
                label: 'Service - refers to the Website.',
              },
              {
                label:
                  'Service Provider - means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.',
              },
              {
                label:
                  'Usage Data - refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).',
              },
              {
                label:
                  'You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.',
              },
              {
                label:
                  'Website refers to BDD Web Invoicing System, accessible from',
                link: 'https://bis.bolehdicoba.com/',
              },
            ],
            styledList: true,
          },
        ],
      },
      {
        title: 'Collecting and Using Your Personal Data',
        subcontent: [
          {
            title: 'Types of Data Collected',
            deepSubContent: [
              {
                title: 'Personal Data',
                description:
                  'While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:',
                list: [{ label: 'Usage Data' }],
                styledList: true,
              },
              {
                title: 'Usage Data',
                description: `Usage Data is collected automatically when using the Service.\n\nUsage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.\n\nWhen You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.\n\nWe may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.`,
              },
              {
                title: 'Tracking Technologies and Cookies',
                description:
                  'We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies We use may include:',
                list: [
                  {
                    label:
                      'Cookies or Browser Cookies. A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies.',
                  },
                  {
                    label:
                      'Web Beacons. Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity).',
                  },
                ],
                styledList: true,
                middleText:
                  'Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser. Learn more about cookies on the Free Privacy Policy website article.\n\nWe use both Session and Persistent Cookies for the purposes set out below:',
                middleList: [
                  {
                    label:
                      'Necessary / Essential Cookies\n\nType: Session Cookies\n\n Administered by: Us\n\nPurpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.',
                  },
                  {
                    label:
                      'Necessary / Essential Cookies\n\nType: Session Cookies\n\n Administered by: Us\n\nPurpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.',
                  },
                  {
                    label:
                      'Necessary / Essential Cookies\n\nType: Session Cookies\n\n Administered by: Us\n\nPurpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.',
                  },
                ],
                finalText:
                  'For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy.',
              },
            ],
          },
          {
            title: 'Use of Your Personal Data',
            description:
              'The Company may use Personal Data for the following purposes:',
            list: [
              {
                label:
                  'To provide and maintain our Service, including to monitor the usage of our Service.',
              },
              {
                label:
                  'To manage Your Account: to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.',
              },
              {
                label:
                  'For the performance of a contract: the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.',
              },
              {
                label: `To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.`,
              },
              {
                label:
                  'To provide You with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.',
              },
              {
                label:
                  'To manage Your requests: To attend and manage Your requests to Us.',
              },
              {
                label:
                  'For business transfers: We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.',
              },
              {
                label:
                  'For other purposes: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.',
              },
            ],
            middleText:
              'We may share Your personal information in the following situations:',
            middleList: [
              {
                label:
                  'With Service Providers: We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.',
              },
              {
                label:
                  'For business transfers: We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.',
              },
              {
                label:
                  'With Affiliates: We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.',
              },
              {
                label:
                  'With business partners: We may share Your information with Our business partners to offer You certain products, services or promotions.',
              },
              {
                label:
                  'With other users: when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.',
              },
              {
                label:
                  'With Your consent: We may disclose Your personal information for any other purpose with Your consent.',
              },
            ],
            styledList: true,
          },
          {
            title: 'Retention of Your Personal Data',
            description:
              'The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.\n\nThe Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.',
          },
          {
            title: 'Transfer of Your Personal Data',
            description: `Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ from those from Your jurisdiction.\n\nYour consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.\n\nThe Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.`,
          },
          {
            title: 'Delete Your Personal Data',
            description:
              'You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.\n\nOur Service may give You the ability to delete certain information about You from within the Service.\n\nYou may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.\n\nPlease note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.',
          },
          {
            title: 'Disclosure of Your Personal Data',
            deepSubContent: [
              {
                title: 'Business Transactions',
                description:
                  'If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.',
              },
              {
                title: 'Law enforcement',
                description:
                  'Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).',
              },
              {
                title: 'Other legal requirements',
                description:
                  'The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:',
                list: [
                  { label: 'Comply with a legal obligation' },
                  {
                    label:
                      'Protect and defend the rights or property of the Company',
                  },
                  {
                    label:
                      'Prevent or investigate possible wrongdoing in connection with the Service',
                  },
                  {
                    label:
                      'Protect the personal safety of Users of the Service or the public  ',
                  },
                  { label: 'Protect against legal liability' },
                ],
                styledList: true,
              },
            ],
          },
          {
            title: 'Security of Your Personal Data',
            description:
              'The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.',
          },
        ],
      },
      {
        title: `Children's Privacy`,
        description: `Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.\n\nIf We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.`,
      },
      {
        title: 'Links to Other Websites',
        description: `Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.\n\nWe have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.`,
      },
      {
        title: 'Changes to this Privacy Policy',
        description: `We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.\n\nWe will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.\n\nYou are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.`,
      },
      {
        title: 'Contact Us',
        description:
          'If you have any questions about this Privacy Policy, You can contact us:',
        list: [
          {
            label: 'finance@bolahdicoba.com',
          },
        ],
        styledList: true,
      },
    ],
  },
  {
    id: '3',
    sections: [
      {
        title: 'Refund Terms and Policy',
        description:
          'In case you received an invoice that is not in accordance with the received service, kindly reach out to our Customer service through Whatsapp to 0813 3239 1051 or email to finance@bolehdicoba.com for refund application and request by including detailed information regarding:',
        list: [
          { label: 'Company/Brand Name' },
          { label: 'Invoice Number' },
          { label: 'Invoice Date' },
          { label: 'Complaint Details' },
          { label: 'Evidences related to the complaint' },
        ],
        middleText:
          'Refund of the payment that has been paid will be processed by bank wire transfer. Refund will only be applicable if we have agreed the complaint and related evidences you have submitted.',
        styledList: true,
      },
    ],
  },
];

export const SITEPOLICY_LINK_ID = [
  {
    id: '1',
    title: 'Ketentuan Layanan BDD Web Invoicing System',
    scrollTo: 'terms-of-service',
  },
  {
    id: '2',
    title: 'Kebijakan Privasi BDD Web Invoicing System',
    scrollTo: 'privacy-policy',
  },
  {
    id: '3',
    title: 'Kebijakan dan Ketentuan Pengembalian Dana',
    scrollTo: 'refund-policy',
  },
];

export const SITEPOLICY_LINK_EN = [
  {
    id: '1',
    title: 'BDD Web Invoicing System Terms Of Service',
    scrollTo: 'terms-of-service',
  },
  {
    id: '2',
    title: 'BDD Web Invoicing System Privacy Policy',
    scrollTo: 'privacy-policy',
  },
  {
    id: '3',
    title: 'Refund Terms and Policy',
    scrollTo: 'refund-policy',
  },
];
